import React from 'react';

import { AUTO_INSURANCE_VERTICAL } from 'types/marketplaceTiles.constants';
import { BulletList, Bullet } from 'components/BulletList';
import { Button } from 'components/form/Button';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { ReactComponent as TooltipOutline } from 'style/icons/tooltip-outline.svg';
import Label from 'components/form/Label/Label';
import OText from 'components/CText/OText';
import './StandardAutoInsuranceOffer.scss';

const StandardAutoInsuranceOffer = props => {
  const { offerMetadata, clickApplyHandler, datatestid } = props;

  const bullets = offerMetadata?.bullets?.map((item, index) => {
    if (index <= 2) {
      return (
        <Bullet key={item} className="text-14 margT8">
          <OText text={item} />
        </Bullet>
      );
    }
    return null;
  });

  return (
    <FlexContainer className="autoInsuranceOffer flex-container items-align-center grayShadow16 border-rad8px padL48 padR40 m-padLR16 padTB24 margB16 m-flex-column">
      <FlexContainer className="offerImageContainer justify-center align-items-center">
        <img
          className="offerImage mblock link"
          alt={`${offerMetadata?.displayName} Logo`}
          src={`${offerMetadata?.imageLink}`}
          onClick={e =>
            clickApplyHandler(e, props.enableInsurancePrefill, true)
          }
        />
      </FlexContainer>

      <FlexContainer className="offerInfoContainer flex-column margL48 margR24 m-marglr0 m-margTB16">
        <FlexContainer>
          <Label
            type="Subtitle-1"
            className={'t-hide'}
            onClick={e =>
              clickApplyHandler(e, props.enableInsurancePrefill, true)
            }
            dangerouslySetInnerHTML={{
              __html: offerMetadata?.title,
            }}
          />
          <Label
            type="Subtitle-2"
            className={'d-hide'}
            dangerouslySetInnerHTML={{
              __html: offerMetadata?.title,
            }}
          />
        </FlexContainer>

        <FlexContainer>
          <BulletList className="m-lineHeight-1-4 marg0 system_neutral_n400_text">
            {bullets}
          </BulletList>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer className="buttonContainer justify-end items-align-center tablet-justify-center tablet-align-items-center flex-column">
        <CSTooltip
          placement="bottom"
          isInline={true}
          pagePosition={props?.pagePosition}
          allowWrap={true}
          tooltipContent={props?.config?.disclaimers?.autoInsuranceTooltip}
          className="margB4 m-margB0"
          vertical={AUTO_INSURANCE_VERTICAL}
        >
          <Label
            type="text-12"
            className="padtpbt10"
            color="system_neutral_n400_text"
            datatestid={`${datatestid}-prefill-text`}
          >
            <FlexContainer className="align-items-center">
              Your information may be pre-filled{' '}
              <TooltipOutline aria-hidden="true" />
            </FlexContainer>
          </Label>
        </CSTooltip>
        <Button
          mrphType="primary"
          onClick={e =>
            clickApplyHandler(e, props?.enableInsurancePrefill, true)
          }
          className="applyNowButton m-margT4 border-rad100px"
        >
          <Label type="Subtitle-2" color="primary_cta_text_light" tabIndex="-1">
            Get Quote
          </Label>
        </Button>
        <div className="m-format100 lineHeight-1-33 text-center text-12 system_neutral_n400_text margT8">
          {props?.applyNowLabelText}
        </div>
      </FlexContainer>
    </FlexContainer>
  );
};

export default StandardAutoInsuranceOffer;
